import React from "react";
import "./Services.css";
import { BsCheck } from "react-icons/bs";

const Services = () => {
  return (
    <section id="services">
  
      <h2>Resume</h2>
      <div className="container services-container">
        <article className="service">
          <div className="service-head">
            <h3>Education </h3>
          </div>
          <ul className="service-list">
            <li>
              <BsCheck className="service-list-icon" />
              <p>Student at National Institute of Technology.Patna</p>
            </li>
            <li>
              <BsCheck className="service-list-icon" />
              <p>B.Tech In Mechanical Engineering (2020 - 2024)</p>
            </li>
            <li>
              <BsCheck className="service-list-icon" />
              <p>CGPA - 7.8</p>
            </li>
         
          </ul>
        </article>
        {/* END OF UI/UX */}
        <article className="service">
          <div className="service-head">
            <h3>Technical Skills</h3>
          </div>
          <ul className="service-list">
            <li>
              <BsCheck className="service-list-icon" />
              <p>#C , #c++,  #Javascript.</p>
            </li>
            <li>
              <BsCheck className="service-list-icon" />
              <p>Database: #SQL , #MongoDB .</p>
            </li>
            <li>
              <BsCheck className="service-list-icon" />
              <p>Other: HTML, CSS ,Javascript,React,express,node.js .</p>
            </li>
           
          </ul>
        </article>
        {/* END OF WEB DEVELOPMENT */}
        <article className="service">
          <div className="service-head">
            <h3>Experience</h3>
          </div>
          <ul className="service-list">
            <li>
              <BsCheck className="service-list-icon" />
              <p>Developed and integrated the user interface using React,js.</p>
            </li>
            <li>
              <BsCheck className="service-list-icon" />
              <p>Worked closely with the Backend team for Api integration at the fronted.</p>
            </li>
            <li>
              <BsCheck className="service-list-icon" />
              <p>Identified bugs and performance issues in the existing code and suggested possible improvement/solutions for them .</p>
            </li>
            <li>
              <BsCheck className="service-list-icon" />
              <p>Technologies used javascript , React.js, Git, Github, Redux,Node.js, Express,MongoDB</p>
            </li>
            
          </ul>
        </article>
      </div>
    </section>
  );
};

export default Services;